import { render } from "./dashboardMetriks.vue?vue&type=template&id=40a200fa&scoped=true"
import script from "./dashboardMetriks.vue?vue&type=script&lang=js"
export * from "./dashboardMetriks.vue?vue&type=script&lang=js"

import "./dashboardMetriks.vue?vue&type=style&index=0&id=40a200fa&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40a200fa"]])

export default __exports__